import { apiGet, apiPatch } from './client';
import type {
  ForwardInterestSetting,
  ForwardInterestSettingBatchRequest,
  ForwardInterestSettingNew,
} from '../types/ForwardInterestSetting';

export function getForwardInterestSettings(): Promise<ForwardInterestSetting[]> {
  return apiGet<ForwardInterestSetting[]>('/api/forward-interest-settings');
}

export function saveForwardInterestSettingsBatch(
  added: ForwardInterestSettingNew[],
  modified: ForwardInterestSetting[],
  deletedIds: number[],
): Promise<ForwardInterestSetting[]> {
  return apiPatch<ForwardInterestSettingBatchRequest, ForwardInterestSetting[]>(
    '/api/forward-interest-settings/batch',
    { added, modified, deleted: deletedIds },
  );
}
